import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navbarRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Function to close the menu when clicked outside
  const handleClickOutside = (event) => {
    if (navbarRef.current && !navbarRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  };

  // Attach event listener on mount and detach on unmount
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-logo">GETFITFAST</div>

        <ul className={`nav-list ${isMenuOpen ? "open" : ""}`} ref={navbarRef}>
          <li className="dropdown-menu-subitem">
            <Link to="/" className="dropdown-item">
              Home
            </Link>
          </li>
          <li className="dropdown-menu-subitem">
            <Link to="/calculator/bmi-calculator" className="dropdown-item">
              Body Mass Index (BMI)
            </Link>
          </li>
          <li className="dropdown-menu-subitem">
            <Link to="/calculator/protein-intake-calculator" className="dropdown-item">
              Protein Intake Calculator
            </Link>
          </li>
          <li className="dropdown-menu-subitem">
            <Link
              to="/calculator/advanced-protein-calculator"
              className="dropdown-item"
            >
              Advanced Protein Intake Calculator
            </Link>
          </li>
          <li className="dropdown-menu-subitem">
            <Link to="/calculator/calorie-calculator" className="dropdown-item">
              Daily Caloric Needs
            </Link>
          </li>
          <li className="dropdown-menu-subitem">
            <Link to="/calculator/body-fat-calculator" className="dropdown-item">
              Body Fat Percentage
            </Link>
          </li>
        </ul>

        {/* Hamburger menu for mobile */}
        <div className="hamburger" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
